import axios, { InternalAxiosRequestConfig, AxiosResponse } from "axios";
import router from "@/router";
import { localCache } from "@/utils/cache";
import { ElMessageBox, ElMessage } from "element-plus";
import baseURL from "@/config/base-url";
import Cookies from "js-cookie";
console.log(Cookies.get("admin_id"), "baseURL", baseURL);

// 创建 axios 实例
const service = axios.create({
  baseURL: baseURL,
  timeout: 50000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    'cookie': Cookies.get("admin_id"),
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response?.data) {
      const { code, message } = response.data;
      //没有 code
      if (!code) {
        return response.data;
      } else {
        if (code !== 0) {
          ElMessage.error(message || "系统出错");
          if (code === 101) {
            ElMessageBox.confirm("当前页面已失效，请重新登录", "提示", {
              confirmButtonText: "确定",
              type: "warning",
            })
              .then(() => {
                localCache.clearCache();
                window.location.href = `/#/login`;
                return;
              })
              .catch(() => {
                localCache.clearCache();
                window.location.href = `/#/login`;
                return;
              });
          }
        } else if (code == 1) {
          console.log("router", router.currentRoute.value.fullPath);
          ElMessage.error(message || "系统出错");
          window.location.href = `/#/login`;
          // window.location.reload();
          localCache.clearCache();
          return;
        } else {
          return response.data;
        }
      }

      // 响应数据为二进制流处理(Excel导出)
      if (response.data instanceof ArrayBuffer) {
        return response;
      }
    } else {
      return response;
    }
    // return Promise.reject(new Error(message || "Error"));
  },
  (error: any) => {
    console.log("error---", error);
    if (error.response.data) {
      const { code, message } = error.response.data;
      ElMessage.error(message || "系统出错");
      localCache.clearCache();
    }
    return Promise.reject(error.message);
  }
);

// 导出 axios 实例
export default service;
